"use strict";

import angular from "angular";
import _ from "lodash";
import { EventEmitterAdapter } from "../../../presentation/adpters/EventEmitterAdapter/EventEmitterAdapter";
import updateConecteDialogTemplate from "./update-conecte-dialog/update-conecte-dialog.html";

export class ElectronService {
    constructor(DSNDialogService) {
        this.DSNDialogService = DSNDialogService;
        this.EventEmitterAdapter = new EventEmitterAdapter();

        this.electronCurrentVersion = "1.0.7";
    }

    async isUpdated() {
        let response = undefined;

        setTimeout(() => {
            if (typeof response === "undefined") {
                this.openDialogUpdate();
            }
        }, 5000);

        response = await this.EventEmitterAdapter.exec({
            eventIdentifier: "message",
            params: {
                method: "version"
            }
        });

        if (_.get(response, "version") !== this.electronCurrentVersion) {
            this.openDialogUpdate();
            return false;
        }
        return true;
    }

    openDialogUpdate() {
        this.DSNDialogService.custom({
            controller: "UpdateConecteDialogController as $ctrl",
            clickOutsideToClose: false,
            escapeToClose: false,
            locals: {
                width: "516px",
                title: "Versão do Nucont Integrações desatualizada!",
                templateHtml: updateConecteDialogTemplate
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }
}

angular
    .module("nucont.shared")
    .service("ElectronService", ["DSNDialogService", ElectronService]);
